var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPopularProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#EE6F44"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6239 33.8312C17.5223 32.5794 16.4207 31.2776 15.7197 29.7253C15.0187 28.073 14.8184 26.1703 15.1689 24.3677C15.5195 22.5651 16.3206 20.8627 17.4722 19.4106C17.3721 20.6624 17.8228 21.9642 18.674 22.9156C18.1732 20.5122 18.9744 17.9085 20.5767 16.0058C22.1789 14.1031 24.3821 12.8512 26.6854 12C25.5337 13.2017 25.3835 15.1044 25.8342 16.7067C26.2848 18.309 27.2362 19.711 28.0874 21.1631C28.9386 22.6151 29.7398 24.1173 29.7898 25.7697C30.2405 24.9185 30.7412 24.0672 31.0416 23.1159C31.3421 22.1645 31.4923 21.1631 31.2419 20.2117C32.1432 21.3133 32.644 22.4148 32.8943 23.8169C33.1447 25.2189 33.0946 26.6709 32.9444 28.073C32.7441 29.6252 32.3435 31.2275 31.4923 32.5293C30.4909 34.0815 28.8886 35.1831 27.1361 35.7839C24.0316 36.3348 20.9772 35.8841 18.6239 33.8312Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4293 35.6838C26.5352 37.2861 30.591 32.4292 28.3377 28.6738C28.3377 28.6237 28.2876 28.6237 28.2876 28.5737C28.4879 30.6266 27.9872 32.1288 27.0358 32.98C27.5366 31.7783 27.1861 30.3763 26.5852 29.1746C25.9843 28.0229 25.1331 26.9714 24.4822 25.8698C23.8312 24.7182 23.3306 23.4163 23.631 22.1145C22.4293 23.0158 21.5781 24.3677 21.2276 25.8197C20.877 27.2718 21.0773 28.8741 21.7283 30.2261C20.9772 29.6753 20.4264 28.774 20.3764 27.8226C19.5752 28.774 19.0745 30.0258 19.1246 31.2776C19.1246 33.2303 20.6768 34.9828 22.4293 35.6838Z",
    fill: "#F7BAA6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularProducts);
export default __webpack_public_path__ + "static/media/popular-products.80ba214b92f1806c8df117b85211477e.svg";
export { ForwardRef as ReactComponent };